import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pageable, FilterSpec, WrapperPageableResponse } from './service-common';

export interface TaxRegimeDTO {
  id: number;
  code: string;
  name: string;
  description?: string;
  state?: 'ACTIVE' | 'INACTIVE';
}

export type TaxRegimeFilterSpec = FilterSpec;
export type ListTaxRegimeFilterSpec = FilterSpec;
export type WrapperPageableResponseTaxRegimeDTO = WrapperPageableResponse<TaxRegimeDTO>;

@Injectable({
  providedIn: 'root'
})
export class TaxRegimeService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  listTaxRegimes(
    spec: ListTaxRegimeFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseTaxRegimeDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseTaxRegimeDTO>(
      `${this.apiUrl}/tax-regimes/list`,
      { params }
    );
  }

  /** Obtiene toda la lista de regímenes fiscales sin filtros (para select/dropdown). */
  getAllTaxRegimes(): Observable<WrapperPageableResponseTaxRegimeDTO> {
    return this.listTaxRegimes({}, { page: 0, size: 500, sort: ['description,asc'] });
  }
}
